import React, { Component, PropTypes } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import classnames from 'classnames';
import { Input, Table, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import  VendSystems  from '././vendSystems';
import VendServerAdmins from '././vendServerAdmins';
import VendServerPorts from '././vendServerPorts';
import VendServerVisibility from '././vendServerVisibility';
import moment from 'moment';
import { connect } from 'react-redux';

class VendServers extends Component {
    static displayName = VendServers.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            loading: this.props.servpk === null ? true : false,
            serverOptions: [],
            thisServerData: this.props.servpk === null ? [] : this.props.servpk,
            tabActive: null,
            servActive: null,
            adminOptions: [],
            visOptions: [],
            portOptions: [],
        }
        if (this.props.servpk == null) {
            this.getServerOptions();
        }
        else {
            this.setState({
                loading: false
            })
        }
    }

    async getServerOptions() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetVendServers', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            serverOptions: data
        })
    }

    componentDidMount() {

    }

    getThisServer(pk) {
        this.setState({
            thisServerData: this.state.serverOptions.filter(filter => {
                return filter.pk === pk
            }),
            loading: false
        })
    }

    tabToggle(tab) {
        if (this.state.tabActive !== tab) {
            this.setState({
                tabActive: tab
            });
        }
    }

    showDataView() {
        return (<div>
            <Table>
                <thead>
                    <tr>
                        <th>Server Name</th>
                        <th>System</th>
                        <th>IP</th>
                        <th>OS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{this.state.thisServerData[0].servername}</td>
                        <td>{this.state.thisServerData[0].sysname}</td>
                        <td>{this.state.thisServerData[0].ip}</td>
                        <td>{this.state.thisServerData[0].os}</td>
                    </tr>
                </tbody>
            </Table>
            <br />
            <Nav tabs>
                {this.props.renderSource != "sys" && <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '1' })} onClick={() => this.tabToggle('1')}>
                        Systems
                    </NavLink>
                </NavItem>}
                <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '2' })} onClick={() => this.tabToggle('2')}>
                        Administrators
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '3' })} onClick={() => this.tabToggle('3')}>
                        Visibility
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '4' })} onClick={() => this.tabToggle('4')}>
                        Open Ports
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={this.state.tabActive}>
                {this.props.renderSource != "sys" && <TabPane tabId='1'>
                    <div className="vendorChild"><VendSystems userData={this.props.userData} syspk={this.state.thisServerData[0].syspk} renderSource={"serv"} /></div>
                </TabPane>}
                <TabPane tabId='2'>
                    <div className="vendorChild"><VendServerAdmins userData={this.props.userData} servpk={this.state.thisServerData[0].pk} /></div>
                </TabPane>
                <TabPane tabId='3'>
                    <div className="vendorChild"><VendServerVisibility userData={this.props.userData} servpk={this.state.thisServerData[0].pk} /></div>
                </TabPane>
                <TabPane tabId='4'>
                    <div className="vendorChild"><VendServerPorts userData={this.props.userData} servpk={this.state.thisServerData[0].pk} /></div>
                </TabPane>
            </TabContent>
        </div>)
    }

    render() {
        let displayView = <div></div>
        if (!this.state.loading === true) { displayView = this.showDataView(); }
        return (<div>
            {this.props.servpk == null && <h2>Servers</h2>}<p />
            {this.props.servpk == null && <Input type="select" name="server" id="server" defaultValue="DEFAULT" onChange={(e) => this.getThisServer(e.target.value)}>
                <option value="DEFAULT" disabled>Select...</option>
                {this.state.serverOptions.map(item => (
                    <option value={item.pk}>{item.servername}</option>
                )) }
            </Input>}
            <br />
            {displayView}
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(VendServers);